import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    dailyCostReportList: (date) => {
        return HTTP.get('/account/report_capital_today?date='+date, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}